module.exports = __webpack_public_path__ + "img/komodaru_cont01.6605b1b9.png";